import React, { useState } from 'react';
import { ChatBubbleIcon } from '@radix-ui/react-icons';
import BugReportModal from './BugReportModal';

export default function FloatingHelpButton() {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			{/* Floating Button */}
			<div className="fixed bottom-6 right-6 z-40">
				<button
					onClick={() => setIsOpen(true)}
					className="group relative bg-brand-600 text-white p-4 rounded-full shadow-lg hover:bg-brand-700 transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
					aria-label="Get Help"
				>
					<ChatBubbleIcon className="w-6 h-6" />

					{/* Tooltip */}
					<div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
						<div className="bg-foreground text-background text-sm rounded px-3 py-2 whitespace-nowrap">
							Need help? Report a bug
							<div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-foreground"></div>
						</div>
					</div>

					{/* Pulse animation for attention */}
					<span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
				</button>
			</div>

			{/* Bug Report Modal */}
			<BugReportModal
				open={isOpen}
				onOpenChange={setIsOpen}
			/>
		</>
	);
}
